import { REISIFT_URL } from "@containers/NicheFiles/utils/legacySubscription";

/**
 * Hosts on which the DataFlik application is considered retired. On these hosts
 * every non-superadmin account is blocked from the app and redirected to the new
 * application. Other environments (local dev / staging) are left untouched so
 * internal testing keeps working. Extend this list if more domains are retired.
 */
export const RETIRED_HOSTS = ["app.dataflik.com"];

/** Where retired users are sent. */
export const RETIREMENT_REDIRECT_URL = REISIFT_URL;

/** Copy shown on the retirement screen. */
export const RETIREMENT_TITLE = "The Dataflik system has been retired.";
export const RETIREMENT_DESCRIPTION = "You will be redirected to the new application.";

export const isRetiredHost = (): boolean =>
  typeof window !== "undefined" && RETIRED_HOSTS.includes(window.location.hostname);
